import { createRouter } from '@tanstack/react-router';

import { queryClient } from './lib/query-client';
import { routeTree } from './routeTree.gen';

/** queryClient у контексті: guard оператора читає сесію до малювання екрана. */
export const router = createRouter({
	routeTree,
	context: { queryClient },
	defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}
